<script setup lang="ts">
import { defineProps } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useUtmTracking } from "~/composables/useUtmTracking"

const router = useRouter()
const { buildRedirectUrl } = useUtmTracking()
const route = useRoute()

const props = defineProps({
  text: { type: String, required: true },
  action: { type: Function, default: () => { } },
  color: { type: String, default: "#0027AF" },
  width: { type: String, default: "auto" },
  height: { type: String, default: "auto" },
  to: { type: String, default: "" },
  href: { type: String, default: "" },
  target: { type: String, default: "_self" },
  disabled: { type: Boolean, default: false },
  fontSize: { type: String, default: "15px" },
  class: { type: String, default: "" },
  ctaName: { type: String, default: "" },
  ariaLabel: { type: String, default: "" },
  textColor: { type: String, default: "#fff" },
})

const computedWidth = () => {
  if (props.width === "full") return "100%"
  if (props.width === "auto") return "auto"
  return props.width
}

const handleClick = () => {
  if (props.disabled) return // do nothing if disabled
  if (props.href) {
    // If href contains invest.equirize.com, add UTM parameters and CTA name
    let finalHref = props.href
    if (props.href.includes('invest.equirize.com')) {
      finalHref = buildRedirectUrl(props.href, route.path, props.ctaName || undefined)
    }
    window.open(finalHref, props.target)
  } else if (props.to) {
    navigateTo(props.to)
  } else {
    props.action()
  }
}
</script>

<template>
  <button @click="handleClick" :disabled="props.disabled" :class="props.class"
    :aria-label="props.ariaLabel || props.text" :style="{
      width: computedWidth(),
      backgroundColor:props.disabled ? '#f3f4f6' : props.color,
      color: props.disabled ? '#6b7280' : props.textColor,
      border: 'none',
      borderRadius: '4px',
      padding: '8px 10px',
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      textTransform: 'none',
      boxShadow: props.disabled ? 'none' : '0px 2px 4px rgba(0,0,0,0.2)',
      opacity: props.disabled ? 0.6 : 1,
      transition: 'opacity 0.2s',
      fontSize: props.fontSize
    }">
    {{ text }}
  </button>
</template>

<style scoped>
.sign_up_initiated {}
</style>
